import React, { useState } from 'react'
import { Image, StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text } from '@components'
import { initialsOf } from '@utils'

interface EventAvatarProps {
  firstName: string
  lastName?: string
  avatarUrl?: string | null
  size?: number
  ring?: boolean
}

/** Photo when there is one, otherwise initials on the brand tint. */
export function EventAvatar({
  firstName,
  lastName,
  avatarUrl,
  size = 56,
  ring = false,
}: EventAvatarProps) {
  const theme = useTheme()
  const [failed, setFailed] = useState(false)
  const frame = {
    width: size,
    height: size,
    borderRadius: size / 2,
    borderWidth: ring ? 3 : 0,
    borderColor: theme.colors.white,
  }

  if (avatarUrl && !failed) {
    return (
      <Image
        source={{ uri: avatarUrl }}
        style={[frame, { backgroundColor: theme.colors.grey }]}
        onError={() => setFailed(true)}
      />
    )
  }
  return (
    <View
      style={[
        frame,
        styles.initials,
        {
          backgroundColor: theme.colors.sidebar,
          borderWidth: ring ? 3 : 1,
          borderColor: ring ? theme.colors.white : theme.colors.primary,
        },
      ]}
    >
      <Text
        type="bodyBold"
        color={theme.colors.primary}
        style={{ fontSize: Math.round(size * 0.36) }}
      >
        {initialsOf(firstName, lastName)}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  initials: { alignItems: 'center', justifyContent: 'center' },
})
